<template>
  <div class="cont">
    <div class="tc44 fs24 tcenter mb20">{{info.title}}</div>
    <div class="tcaa fs15 tcenter">
      <span class="mr20" v-if="info.admin_name">发布者：{{info.admin_name}}</span>
      <span class="mr20" v-if="info.origin">来源：{{info.origin}}</span>
      <span class="mr20">发布时间：{{info.release_time}}</span>
      <span class="mr20">浏览次数：{{info.views_count}}</span>
    </div>
    <div class="ncont fs16 lh20" v-html="info.detail">
    </div>
    <a v-for="(item,index) in info.data" :key="item.id" class="downloada" target="_blank" :href="item" :download="info.title+''+index">附件【附件{{index + 1}} 请点击下载】</a>
    <!-- <a class="down" v-if="info.data != ''" :href="$request.request_url+'article/get-file-content?path='+decodeURIComponent(info.data[0])">附件下载</a> -->
  </div>
</template>

<script>
  export default {
    name: "detail",
    props: [
      'info',
    ],
    methods:{

    }
    
  }
  
</script>

<style scoped>
 .downloada{font-size: 16px;}
 .downloada:hover{color: #2727a2;}
  .znotice-wrap .notices{padding: 40px 50px 0 35px;}
  .znotice-wrap .notices .cont{padding: 60px 0 80px 20px;}
  .notices .ncont{padding: 40px 20px;line-height: 2.5;}
  .down{width:80px;height:30px;line-height:30px;text-align: center;cursor: pointer;margin-left:20px;background:#E9E9E9;border:1px solid #727272;padding:2px 5px}
</style>



// WEBPACK FOOTER //
// src/components/main/detail.vue